import { useState, useEffect, useRef } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, renderRedirect, setTokenHeader, getJwtFromCookies, IsMbrRolePv } from "../../../module_auth/AuthService"
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../../component/common/Toast"
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { plans } from "./TalentCommonUtil"
import { ServiceDisclaimerCard } from "../../common/ServiceDisclaimerCard";
import { CategorySelect } from "./CategorySelect";

export function TalentRegMypage() {
    const [title, setTitle] = useState("");
    const [categoryCode, setCategoryCode] = useState("");
    const [priceValue, setPriceValue] = useState(0);
    const [priceUnit, setPriceUnit] = useState("HOUR");
    const [priceNote, setPriceNote] = useState("");
    const [descriptionText, setDescriptionText] = useState("");
    const [expertIntroText, setExpertIntroText] = useState("");
    // const [kakaoLink, setKakaoLink] = useState("");
    // const [whatsAppLink, setWhatsAppLink] = useState("");
    // const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");

    const [mainFile, setMainFile] = useState(null);
    const [subFiles, setSubFiles] = useState([null, null, null, null]);

    const [mbrId, setMbrId] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("/");
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    const [mainPreview, setMainPreview] = useState(null); // 최종 자른 이미지 미리보기 (DataURL)
    const [selectedImage, setSelectedImage] = useState(null); // 원본 이미지 (Cropper용)
    const cropperInstance = useRef(null); // Cropper 인스턴스
    const [accessToken, setAccessToken] = useState("");
    const [cityList, setCityList] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedCityId, setSelectedCityId] = useState("");
    const [serviceMode, setServiceMode] = useState("OFFLINE");
    const [selectedPlanCode, setSelectedPlanCode] = useState("");
    const [isPriceNegotiable, setIsPriceNegotiable] = useState(0);
    const [hasVisaTaxConsent, setHasVisaTaxConsent] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 모달 상태
    const [showMainCropModal, setShowMainCropModal] = useState(false);

    // 권장 규격 (비율 계산용)
    const TARGET_WIDTH = 212;
    const TARGET_HEIGHT = 159;

    const navigate = useNavigate();

    useEffect(() => {
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            setRedirectUrl("/login")
            setRedirect(true)
        } else if (!IsMbrRolePv(getJwtFromCookies())) {
            setRedirectUrl("/")
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            getCityList();
        }
    }, []);

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCityList(response.cityEntityList)

                let cityOptions = response.cityEntityList.map(city => ({
                    value: city.id,    // 도시 객체의 'id'를 'value'로 매핑
                    label: city.cityName   // 도시 객체의 'name'을 'label'로 매핑
                }));
                setOptions(cityOptions);

            }).catch(error => console.log(error))
    }

    // 파일 선택 시 실행
    const handleMainFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // 일단 파일 정보만 저장 (파일명 표시용)
            setMainFile(file);

            // 원본 파일을 읽어 Cropper 모달에 띄움
            const reader = new FileReader();
            reader.onloadend = () => {
                if (cropperInstance.current) {
                    cropperInstance.current.destroy();
                    cropperInstance.current = null;
                }
                setSelectedImage(reader.result); // 원본 이미지 세팅
                setShowMainCropModal(true); // 모달 열기
            };
            reader.readAsDataURL(file);
        }
    };

    // 모달에서 '자르기 및 적용' 클릭 시 실행
    const handleMainCrop = () => {
        if (cropperInstance.current) {
            const croppedCanvas = cropperInstance.current.getCroppedCanvas({
                // 최종 결과물 스타일 정의 (필요시 크기 고정 가능)
                width: TARGET_WIDTH,
                height: TARGET_HEIGHT,
            });

            if (croppedCanvas) {
                // 1. 미리보기 업데이트
                const croppedDataURL = croppedCanvas.toDataURL(mainFile.type);
                setMainPreview(croppedDataURL);

                // 2. (옵션) 서버 전송용 Blob 객체 생성
                // 만약 서버가 Blob/File을 요구하면 이 처리가 필요합니다.
                croppedCanvas.toBlob((blob) => {
                    const croppedFile = new File([blob], mainFile.name, { type: mainFile.type });
                    setMainFile(croppedFile); // 최종 자른 파일로 교체
                }, mainFile.type);

                setShowMainCropModal(false); // 모달 닫기
            }
        }
    };

    // 모달 취소 시 실행
    const closeMainCropModal = () => {
        setShowMainCropModal(false);
        setSelectedImage(null);
        // 이미지가 잘리지 않았으므로, input과 상태를 초기화합니다.
        setMainFile(null);
        document.getElementById("mainFileInput").value = "";
    };

    // 최종 이미지 삭제
    const removeMainImage = () => {
        setMainFile(null);
        setMainPreview(null);
        document.getElementById("mainFileInput").value = "";
    };

    const handleSubFileChange = (e, index) => {
        if (e.target.files && e.target.files[0]) {
            const newSubFiles = [...subFiles];
            newSubFiles[index] = e.target.files[0];
            setSubFiles(newSubFiles);
        }
    };

    const clickSubmit = (event) => {
        event.preventDefault();

        const normalizedIsRemote = serviceMode === "OFFLINE" ? 0 : 1;

        if (isSubmitting) {
            return;
        }

        if (!hasVisaTaxConsent) {
            fadeOutToast("독일 내 활동 권한 및 세무 신고 책임 동의가 필요합니다.");
            return;
        }

        // 1. 데이터 검증
        if (!mainFile) {
            fadeOutToast("대표 이미지는 필수입니다.");
            return;
        }

        // 2. FormData 생성 (파일 전송을 위해 필수)
        const formData = new FormData();

        // 3. 파일 추가 (백엔드 @RequestPart 이름과 동일하게)
        formData.append("MainFile", mainFile);
        subFiles.forEach((file) => {
            if (file) formData.append("SubFiles", file);
        });

        // 4. JSON 데이터 추가 (백엔드 @RequestPart("JsonStr") 대응)
        const talentDto = {
            title: title,
            categoryCode: categoryCode,
            priceValue: Number(priceValue),
            priceUnit: priceUnit,
            isPriceNegotiable: isPriceNegotiable,
            priceNote: priceNote,
            descriptionText: descriptionText,
            expertIntroText: expertIntroText,
            email: email,
            selectedCityId: selectedCityId,
            isRemote: normalizedIsRemote,
            selectedPlanCode: selectedPlanCode
        };
        formData.append("JsonStr", JSON.stringify(talentDto));

        // 5. 인증 헤더 설정
        setTokenHeader(getJwtFromCookies());

        // 6. 서버 전송 (fetch)
        // 주의: FormData를 보낼 때는 headers에서 'Content-Type'을 수동으로 세팅하지 않는 것이 좋습니다.
        // 만약 headers 변수에 'Content-Type': 'application/json'이 포함되어 있다면 아래처럼 filter 해야 합니다.
        const uploadHeaders = { ...headers };
        delete uploadHeaders['Content-Type'];

        setIsSubmitting(true);

        fetch(basePort + '/post/talent', {
            method: 'POST',
            headers: uploadHeaders, // Authorization이 포함된 헤더
            body: formData
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                if (data.validRequest) {
                    fadeOutToast("재능서비스가 성공적으로 등록되었습니다.");
                    setTimeout(() => {
                        navigate("/talent_list_mypage");
                    }, 3000);
                } else {
                    fadeOutToast(data.validationMessage || "재능서비스 등록 실패");
                }
            })
            .catch(error => {
                console.error("Error:", error);
                fadeOutToast("서버 통신 중 오류가 발생했습니다.");
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const fadeOutToast = (msg) => {
        setShowToast(true);
        setMsgToast(msg);
        setTimeout(() => setShowToast(false), 3000);
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            {renderRedirect(redirect, redirectUrl)}
            <main className="page landing-page">
                <section className="container" style={{ paddingTop: '100px', paddingBottom: '80px' }}>

                    {/* 상단 헤더 & 브레드크럼 */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 bg-transparent">
                                <li className="breadcrumb-item text-muted">마이페이지</li>
                                <li className="breadcrumb-item active text-muted">재능 서비스 등록</li>
                            </ol>
                        </nav>
                    </div>

                    <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-bottom p-4">
                            <h4 className="mb-0 fw-bold"><i className="bi bi-pencil-square me-2 text-primary"></i>서비스 정보 등록</h4>
                            <p className="text-muted small mb-0 mt-1">고객에게 제공할 서비스 정보를 상세히 작성해 주세요.</p>
                        </div>

                        <div className="card-body p-4 p-md-5">
                            {/* 1. 기본 정보 섹션 */}
                            <div className="section-group mb-5">
                                <h5 className="fw-bold mb-4 border-start border-4 border-primary ps-3">기본 정보</h5>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold text-secondary">서비스 제목</label>
                                    <input className="form-control form-control-lg border-2 shadow-none" type="text"
                                        value={title} onChange={(e) => setTitle(e.target.value)}
                                        placeholder="예: 10년 경력의 비즈니스 번역 서비스" style={{ fontSize: '1.1rem' }} />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">진행 방식</label>
                                        <div className="border rounded-3 px-3 py-2 bg-white">
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeOffline"
                                                    checked={serviceMode === "OFFLINE"}
                                                    onChange={() => setServiceMode("OFFLINE")}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeOffline">
                                                    대면
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeRemote"
                                                    checked={serviceMode === "REMOTE"}
                                                    onChange={() => {
                                                        setServiceMode("REMOTE");
                                                        setSelectedCityId("");
                                                    }}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeRemote">
                                                    온라인/원격
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceMode"
                                                    id="serviceModeHybrid"
                                                    checked={serviceMode === "HYBRID"}
                                                    onChange={() => setServiceMode("HYBRID")}
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeHybrid">
                                                    하이브리드(대면/온라인)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">활동 도시</label>
                                        <select
                                            className="form-select"
                                            value={selectedCityId}
                                            disabled={serviceMode === "REMOTE"}
                                            onChange={(e) => setSelectedCityId(e.target.value)}
                                        >
                                            <option value="">도시 선택</option>
                                            {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                        {serviceMode === "REMOTE" && (
                                            <div className="form-text text-muted mt-2">
                                                온라인/원격 선택 시 활동 도시는 선택할 수 없습니다.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <CategorySelect value={categoryCode} onChange={setCategoryCode} />
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">가격 설정 (유로)</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-2 border-end-0">€</span>
                                            <input className="form-control border-2 shadow-none" type="number" value={priceValue} onChange={(e) => setPriceValue(e.target.value)} />
                                            <select className="form-select border-2 shadow-none" value={priceUnit} onChange={(e) => setPriceUnit(e.target.value)}>
                                                <option value="HOUR">시간당</option>
                                                <option value="ONCE">회당</option>
                                                <option value="DAY">일당</option>
                                            </select>
                                        </div>
                                        <div className="form-check mt-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isPriceNegotiableCheckbox"
                                                checked={isPriceNegotiable === 1}
                                                onChange={(e) => setIsPriceNegotiable(e.target.checked ? 1 : 0)}
                                            />
                                            <label className="form-check-label text-secondary" htmlFor="isPriceNegotiableCheckbox">
                                                가격 협의
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* 노출 플랜 (디자인 통일) */}
                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">노출 플랜 선택</label>
                                        <select
                                            className="form-select border-2 shadow-none"
                                            value={selectedPlanCode}
                                            onChange={(e) => setSelectedPlanCode(e.target.value)}
                                        >
                                            <option value="">플랜 선택</option>
                                            {plans.map((plan, index) => (
                                                <option key={index} value={plan.code}>
                                                    {plan.title} ({plan.price === "0원" ? "무료" : plan.price})
                                                </option>
                                            ))}
                                        </select>
                                        {/* 플랜 선택 시 안내 메시지 */}
                                        {selectedPlanCode && (
                                            <div className="mt-3">
                                                {selectedPlanCode === "FREE" ? (
                                                    /* 무료 플랜 안내 */
                                                    <div className="p-2 small text-muted">
                                                        <i className="bi bi-check-circle me-1"></i>
                                                        관리자 검수 후 순차적으로 일반 목록에 게재됩니다.
                                                    </div>
                                                ) : (
                                                    /* 유료 플랜 안내 (LIFE, MASTER, EXPERT 등) */
                                                    <div className="p-3 rounded" style={{ backgroundColor: '#f0f7ff', fontSize: '0.85rem', color: '#495057', border: '1px solid #cce5ff' }}>
                                                        <div className="fw-bold text-primary mb-2">
                                                            <i className="bi bi-info-circle-fill me-1"></i>
                                                            {plans.find(p => p.code === selectedPlanCode)?.title} 안내
                                                        </div>
                                                        <ul className="list-unstyled mb-2" style={{ lineHeight: '1.7' }}>
                                                            <li>• <strong>노출 기간:</strong> 입금 확인 후 <span className="text-primary fw-bold">30일간</span> 상단 고정</li>
                                                            <li>• <strong>진행 절차:</strong> 관리자 검수 후 <span className="text-dark fw-bold">이메일로 결제 정보</span> 발송</li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>

                            <div className="section-group mb-5 pt-4 border-top">
                                <h5 className="fw-bold mb-3 border-start border-4 border-info ps-3">대표 이미지</h5>
                                <div className="p-4 border rounded-3 bg-light">
                                    <div className="row align-items-center">
                                        {/* 왼쪽: 미리보기 영역 (212x159px 고정) */}
                                        <div className="col-md-4 text-center mb-3 mb-md-0 d-flex justify-content-center overflow-hidden">
                                            <div
                                                className="border rounded-3 bg-white d-flex align-items-center justify-content-center shadow-sm"
                                                style={{ width: '212px', height: '159px' }}
                                            >
                                                {mainPreview ? (
                                                    <img
                                                        src={mainPreview}
                                                        alt="Main Preview"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                    />
                                                ) : (
                                                    <div className="text-center p-3">
                                                        <i className="bi bi-image text-muted display-4"></i>
                                                        <div className="small text-muted mt-2">No Image<br />(212x159 px)</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* 오른쪽: 업로드 컨트롤 */}
                                        <div className="col-md-8">
                                            <label className="form-label text" htmlFor="mainFileInput">메인 썸네일 등록 (필수)</label>
                                            <input
                                                id="mainFileInput"
                                                className="form-control border-2 shadow-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleMainFileChange}
                                            />
                                            <small className="text-muted d-block mt-2">
                                                서비스 목록에 가장 먼저 노출될 대표 사진을 선택해주세요.<br />
                                                (권장 비율: 212 × 159 px - 이미지가 비율에 맞게 잘립니다.)
                                            </small>

                                            {mainFile && (
                                                <div className="mt-2 d-flex align-items-center">
                                                    <span className="text-primary small fw-bold text-truncate" style={{ maxWidth: '200px' }}>
                                                        ✓ {mainFile.name}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger ms-2"
                                                        onClick={removeMainImage}
                                                    >
                                                        삭제
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 대표 이미지 Cropper 모달 */}
                            {showMainCropModal && (
                                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055 }}>
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content shadow-lg border-0">
                                            <div className="modal-header bg-primary text-white">
                                                <h5 className="modal-title fw-bold">대표 이미지 영역 선택</h5>
                                                <button type="button" className="btn-close btn-close-white" onClick={closeMainCropModal}></button>
                                            </div>
                                            <div className="modal-body p-0 text-center bg-black" style={{ minHeight: '400px' }}>
                                                {selectedImage && (
                                                    <img
                                                        src={selectedImage}
                                                        alt="To be cropped"
                                                        ref={(el) => {
                                                            if (el && !cropperInstance.current) {
                                                                cropperInstance.current = new Cropper(el, {
                                                                    // 가장 중요한 부분: 212x159 비율 고정
                                                                    aspectRatio: TARGET_WIDTH / TARGET_HEIGHT,
                                                                    viewMode: 1, // 이미지가 캔버스 밖으로 나가지 않게 함
                                                                    dragMode: 'move', // 배경 이미지를 이동 가능하게 함
                                                                    autoCropArea: 1, // 처음에 꽉 차게 지정
                                                                    restore: false,
                                                                    guides: true,
                                                                    center: true,
                                                                    highlight: false,
                                                                    cropBoxMovable: true,
                                                                    cropBoxResizable: true,
                                                                    toggleDragModeOnDblclick: false,
                                                                });
                                                            }
                                                        }}
                                                        style={{ maxWidth: "100%", maxHeight: "500px" }}
                                                    />
                                                )}
                                            </div>
                                            <div className="modal-footer bg-light">
                                                <div className="text-muted small me-auto">마우스로 드래그하여 원하는 영역을 맞춰주세요.</div>
                                                <button type="button" className="btn btn-secondary" onClick={closeMainCropModal}>취소</button>
                                                <button type="button" className="btn btn-primary fw-bold" onClick={handleMainCrop}>이 영역 사용하기</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* 3. 상세 설명 섹션 */}
                            <div className="section-group mb-5 pt-4 border-top">
                                <h5 className="fw-bold mb-4 border-start border-4 border-warning ps-3">서비스 상세 내용</h5>
                                <div className="mb-5 pb-3">
                                    <label className="form-label fw-semibold">서비스 상세 설명</label>
                                    <ReactQuill theme="snow" value={descriptionText} onChange={setDescriptionText} style={{ height: '300px', marginBottom: '50px' }} />
                                </div>
                                {/* 2. 상세 이미지 섹션 (상세 설명 바로 아래 배치) */}
                                <div className="section-group mb-5 mt-5 pt-5 pt-md-2">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold mb-0 border-start border-4 border-info ps-3">서비스 상세 이미지</h5>
                                        <span className="badge bg-light text-dark border">최대 4장</span>
                                    </div>

                                    <div className="p-4 border rounded-3">
                                        <p className="text-muted small mb-4">서비스의 퀄리티를 보여줄 수 있는 결과물이나 작업 과정 사진을 등록해주세요.</p>
                                        <div className="row g-3">
                                            {Array.from({ length: 4 }).map((_, index) => (
                                                <div key={index} className="col-md-6">
                                                    <div className="input-group">
                                                        <span className="input-group-text bg-light border-2 fw-bold text-muted">{index + 1}</span>
                                                        <input
                                                            className="form-control border-2 shadow-none"
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={(e) => handleSubFileChange(e, index)}
                                                        />
                                                    </div>
                                                    {subFiles[index] && (
                                                        <div className="text-success small mt-1 ps-5">
                                                            <i className="bi bi-check-circle-fill"></i> {subFiles[index].name}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section-group mb-5 mt-5">
                                {/* 헤더 부분: 상세 이미지 섹션과 동일한 스타일 적용 */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="fw-bold mb-0 border-start border-4 border-warning ps-3">전문가 소개</h5>
                                    {/* <span className="badge bg-light text-dark border fw-normal">선택 사항</span> */}
                                </div>

                                <div className="mb-4">
                                    {/* 에디터 영역 */}
                                    <ReactQuill
                                        theme="snow"
                                        value={expertIntroText}
                                        onChange={setExpertIntroText}
                                        placeholder="전문가님의 경력이나 강점을 자유롭게 소개해 주세요."
                                        style={{ height: '250px', marginBottom: '50px' }}
                                    />
                                </div>
                            </div>

                            {/* 4. 커뮤니케이션 채널 (디자인 카드) */}
                            <div
                                className="card border rounded-4 shadow-sm mb-5 bg-white"
                                style={{ marginTop: '75px' }} // 원하는 픽셀값으로 미세 조정
                            >
                                <div className="card-body p-4">
                                    <h5 className="fw-bold mb-4 text-dark">
                                        <i className="bi bi-headset me-2 text-primary"></i>커뮤니케이션 채널
                                    </h5>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="small fw-bold text-muted">이메일 주소</label>
                                            <div className="input-group">
                                                <span className="input-group-text border-0 bg-secondary text-white"><i className="bi bi-envelope"></i></span>
                                                <input className="form-control border bg-light shadow-none" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="contact@email.com" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ServiceDisclaimerCard />

                            <div
                                className="card border rounded-4 shadow-sm bg-white mb-4"
                                style={{
                                    borderRadius: '15px'
                                }}
                            >
                                <div className="card-body p-4">
                                    <div className="small fw-bold text-primary mb-3">필수 동의</div>
                                    <div className="form-check m-0">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="visaTaxConsentCheck"
                                            checked={hasVisaTaxConsent}
                                            onChange={(e) => setHasVisaTaxConsent(e.target.checked)}
                                        />
                                        <label
                                            className="form-check-label text-secondary"
                                            htmlFor="visaTaxConsentCheck"
                                            style={{ lineHeight: '1.7', wordBreak: 'keep-all' }}
                                        >
                                            독일 내 적법한 활동 권한(비자) 확인 및 세무 신고 책임은 본인에게 있음에 동의합니다.
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* 등록 버튼 */}
                            <div className="text-center pt-4 mb-5">
                                <button
                                    className="btn btn-primary px-4 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
                                    style={{
                                        borderRadius: '8px',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        opacity: hasVisaTaxConsent && !isSubmitting ? 1 : 0.65,
                                        cursor: hasVisaTaxConsent && !isSubmitting ? 'pointer' : 'not-allowed'
                                    }}
                                    type="button"
                                    disabled={!hasVisaTaxConsent || isSubmitting}
                                    onClick={clickSubmit}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            <span>등록 중...</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-check2-circle me-1"></i>
                                            <span>서비스 등록</span>
                                        </>
                                    )}
                                </button>
                                <p className="text-muted small mt-3">
                                    등록 완료 시 마이페이지 관리 목록으로 이동합니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <ToastMessage show={showToast} msg={msgToast} />
            </main>
        </div>
    );
}